import React, { useState, useEffect } from "react";
import { Tabs, Tab, Box, CircularProgress } from "@mui/material";
import { useModerationStore } from "../../store/moderationStore";
import { ThresholdsSection } from "./ThresholdsSection";
import { BlocklistSection } from "./BlocklistSection";
import { AllowlistSection } from "./AllowlistSection";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

const TabPanel: React.FC<TabPanelProps> = ({ children, value, index }) => {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`config-tabpanel-${index}`}
      aria-labelledby={`config-tab-${index}`}
    >
      {value === index && <Box sx={{ py: 3 }}>{children}</Box>}
    </div>
  );
};

export interface ConfigurationTabsProps {
  onRefresh: () => void;
}

export const ConfigurationTabs: React.FC<ConfigurationTabsProps> = ({
  onRefresh,
}) => {
  const [tabValue, setTabValue] = useState(0);
  const {
    configResponse,
    blocklist,
    allowlist,
    loadingConfig,
    loadingBlocklist,
    loadingAllowlist,
    loadConfig,
    loadBlocklist,
    loadAllowlist,
  } = useModerationStore();

  useEffect(() => {
    loadConfig();
    loadBlocklist();
    loadAllowlist();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleTabChange = (_event: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
  };

  const isLoading = loadingConfig || loadingBlocklist || loadingAllowlist;

  if (isLoading && !configResponse && !blocklist && !allowlist) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: 200,
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs
          value={tabValue}
          onChange={handleTabChange}
          aria-label="moderation config tabs"
        >
          <Tab label="Thresholds" id="config-tab-0" />
          <Tab label="Blocklist" id="config-tab-1" />
          <Tab label="Allowlist" id="config-tab-2" />
        </Tabs>
      </Box>

      <TabPanel value={tabValue} index={0}>
        <ThresholdsSection onRefresh={onRefresh} />
      </TabPanel>

      <TabPanel value={tabValue} index={1}>
        <BlocklistSection onRefresh={onRefresh} />
      </TabPanel>

      <TabPanel value={tabValue} index={2}>
        <AllowlistSection onRefresh={onRefresh} />
      </TabPanel>
    </>
  );
};
